import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_tien_gui_hach_toan_giay_bao_co_GBC } from '@/lib/templates-base64/GBC';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { useGiayBaoCoContext } from '../context';

interface ActionBarProps {
  onPrintClick?: () => void;
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onPrintMultipleClick?: () => void;
  onExportDataClick?: () => void;
  onImportFromExcelClick?: () => void;
  isDisabledView?: boolean;
}

export const ActionBar = ({
  onPrintClick,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onPrintMultipleClick,
  onExportDataClick,
  onImportFromExcelClick,
  isDisabledView
}: ActionBarProps) => {
  const { exportToExcel, canExport, isExporting } = useGiayBaoCoContext();
  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(excelTemplate_tien_gui_hach_toan_giay_bao_co_GBC, 'Giấy báo có.xlsx');
  };

  return (
    <ActionBarV2 title='Giấy báo có'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick || (() => {})} variant='primary' />
      <ActionButtonV2
        icon={Pencil1Stroke}
        title='Sửa'
        onClick={onEditClick || (() => {})}
        variant='secondary'
        disabled={isDisabledView}
      />
      <ActionButtonV2
        icon={Trash3Stroke}
        title='Xóa'
        onClick={onDeleteClick || (() => {})}
        variant='destructive'
        disabled={isDisabledView}
      />
      <ActionButtonV2
        icon={FileMultipleStroke}
        title='Sao chép'
        onClick={onCopyClick || (() => {})}
        variant='secondary'
        disabled={isDisabledView}
      />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick || (() => {})} variant='secondary' />
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrintClick || (() => {})} variant='secondary' />

      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick || (() => {}),
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: onFixedColumnsClick || (() => {}),
            group: 0
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: onPrintMultipleClick || (() => {}),
            group: 1
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportDataClick || exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 2
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcelClick || (() => {}),
            group: 2
          }
        ]}
      />
    </ActionBarV2>
  );
};
